<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="home">
    <!-- 英雄区：修复轮播图标签错乱问题 -->
    <section class="hero">
      <div class="container">
        <div class="hero__wrap">
          <div class="hero__content">
            <h1 class="hero-title">跨境电商 · TikTok</h1>
            <p class="hero-desc">
              我们专注于为个人/企业提供高品质的跨境解决方案，以简约的理念、专业的能力，助力海外兴趣电商新趋势。
            </p>
            <div class="hero__btns">
              <router-link to="/service" class="nav__link" active-class="nav__link--active">
                <a class="btn btn-primary">查看服务</a>
              </router-link>
              <router-link to="/contact" class="nav__link" active-class="nav__link--active">
                <a class="btn btn-outline">联系我们</a>
              </router-link>
            </div>
          </div>

          <!-- 轮播图容器：重构标签定位逻辑 -->
          <div class="hero__carousel-wrapper">
            <div class="hero__carousel">
              <div class="swiper-container hero-swiper">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <img src="../assets/images/s1.jpg" alt="轮播图1" class="carousel-img" />
                  </div>
                  <div class="swiper-slide">
                    <img src="../assets/images/s2.png" alt="轮播图2" class="carousel-img" />
                  </div>
                  <div class="swiper-slide">
                    <img src="../assets/images/s3.png" alt="轮播图3" class="carousel-img" />
                  </div>
                </div>
              </div>

              <!-- 修复后的装饰标签：精准定位+规整样式 -->
              <div class="carousel-tag tag-1">
                <span class="tag-icon green-icon">✓</span>
                <span class="tag-text">个人跨境</span>
              </div>
              <div class="carousel-tag tag-2">
                <span class="tag-num">500+</span>
                <span class="tag-sub">TikTok/独立站</span>
              </div>
              <div class="carousel-tag tag-3">
                <span class="tag-icon blue-icon">✓</span>
                <span class="tag-text">企业品牌出海</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新增：核心服务板块（放在核心优势上方） -->
    <section class="core-service">
      <div class="container">
        <h2 class="text-center core-service__title">核心服务</h2>
        <div class="core-service__list">
          <!-- 个人跨境方案 -->
          <div class="core-service__item">
            <div class="core-service__icon">👤</div>
            <h3 class="core-service__item-title">个人跨境</h3>
            <p class="core-service__item-desc">为个人提供跨境陪跑服务，一对一指导从选品到运营0-1全流程，全链路资源共享，<span style="font-size:15px;color: #2D4B99">线下/线上</span>双端教学。</p>
          </div>
          <!-- 企业跨境方案 -->
          <div class="core-service__item">
            <div class="core-service__icon">🏢</div>
            <h3 class="core-service__item-title">企业跨境</h3>
            <p class="core-service__item-desc">为企业提供跨境布局规划，<span style="font-size:15px;color: #2D4B99">TikTok+独立站</span>的方式实现海外品牌价值实现，并驱B/C端客户的海外业务增长。</p>
          </div>
          <!-- 就业解决方案 -->
          <div class="core-service__item">
            <div class="core-service__icon">💼</div>
            <h3 class="core-service__item-title">就业解决</h3>
            <p class="core-service__item-desc">为<span style="font-size:15px;color: #2D4B99">转职/就业</span>方向为跨境的用户提供标准化的职能培训，面试优化和长达6个月的跟踪指导，为企业输送专业人才。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心优势 -->
    <section class="advantage">
      <div class="container">
        <h2 class="text-center advantage__title">核心优势</h2>
        <div class="advantage__list">
          <div class="advantage__item">
            <div class="advantage__icon">✓</div>
            <h3 class="advantage__item-title">专业团队</h3>
            <p class="advantage__item-desc">拥有多年行业经验的专业团队，全球市场正向结果反馈</p>
          </div>
          <div class="advantage__item">
            <div class="advantage__icon">✓</div>
            <h3 class="advantage__item-title">定制方案</h3>
            <p class="advantage__item-desc">根据实际情况，提供个性化的定制跨境方案</p>
          </div>
          <div class="advantage__item">
            <div class="advantage__icon">✓</div>
            <h3 class="advantage__item-title">技术保障</h3>
            <p class="advantage__item-desc">持续深入技术研发行业AI系统、插件工具，开源使用</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 用户好评 -->
    <section class="testimonial">
      <div class="container">
        <div class="testimonial__header text-center">
          <h2 class="testimonial-title">用户反馈，<span class="blue-text">口碑相传</span></h2>
          <p class="testimonial-desc">
            听听来自客户的真实声音，了解我们如何助力跨境行业增长
          </p>
        </div>
        <div class="testimonial__list">
          <div class="testimonial__card">
            <div class="testimonial__badge">1</div>
            <div class="testimonial__stars">★★★★★</div>
            <p class="testimonial__content">
              "一个人起步做TK跨境电商的时候很怕自己没有思路和走弯路，有标准化的教学流程成长很快，提供的各种插件工具真是效率神器"
            </p>
            <div class="testimonial__achievement">
              管理15个店铺 月销售额 ¥100万+
            </div>
            <div class="testimonial__user">
              <img src="@/assets/images/head2.jpg" alt="用户头像" class="user-avatar" />
              <div>
                <div class="user-name">张明</div>
                <div class="user-tag">TikTok个人 · 数码3C店</div>
              </div>
            </div>
          </div>
          <div class="testimonial__card">
            <div class="testimonial__badge">2</div>
            <div class="testimonial__stars">★★★★★</div>
            <p class="testimonial__content">
              "一直对跨境行业很感兴趣，也看好TikTok的全球发展趋势，希望通过专业的职业培训进入企业或者跨境公司做跨境运营师"
            </p>
            <div class="testimonial__achievement">
              面试一周5个offer，平均薪资12000+
            </div>
            <div class="testimonial__user">
              <img src="@/assets/images/head3.jpg" alt="用户头像" class="user-avatar" />
              <div>
                <div class="user-name">李小雅</div>
                <div class="user-tag">TikTok运营师 · 转职跨境</div>
              </div>
            </div>
          </div>
          <div class="testimonial__card">
            <div class="testimonial__badge">3</div>
            <div class="testimonial__stars">★★★★★</div>
            <p class="testimonial__content">
              "传统的谷歌、FB等平台投流成本太高了，通过TikTok+独立站的方式同时获取C端和B端的客户，回报效益比传统广告提升了500%"
            </p>
            <div class="testimonial__achievement">
              自然流也很顶，月均有效询盘200+
            </div>
            <div class="testimonial__user">
              <img src="@/assets/images/head1.jpg" alt="用户头像" class="user-avatar" />
              <div>
                <div class="user-name">王建华</div>
                <div class="user-tag">TikTok品牌出海 · 烤箱厂家</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务简介 -->
    <section class="service-intro">
      <div class="container">
        <div class="service-intro__content">
          <h2 class="service-intro__title">我们的服务</h2>
          <p class="service-intro__desc">覆盖个人/企业跨境出海全生命周期的核心服务，从咨询规划到落地执行，全程保驾护航</p>
          <router-link to="/service" class="nav__link" active-class="nav__link--active">
            <a class="btn btn-primary">查看全部服务</a>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

export default {
  name: 'HomeView',
  created() {
    const styles = {
      '--primary-blue': '#2D4B99',
      '--primary-purple': '#5bafb8',
      '--success-green': '#52C41A',
      '--light-blue': '#F0F5FF',
      '--text-main': '#1F2937',
      '--text-white': '#FFFFFF',
      '--bg-base': '#FFFFFF',
      '--spacing-xs': '4px',
      '--spacing-sm': '8px',
      '--spacing-md': '16px',
      '--spacing-lg': '24px',
      '--spacing-xl': '48px',
      '--radius-sm': '4px',
      '--radius-md': '8px',
      '--radius-lg': '12px',
      '--radius-xl': '20px',
      '--shadow-sm': '0 2px 8px rgba(0,0,0,0.06)',
      '--shadow-tech': '0 0 20px rgba(45, 75, 153, 0.15), 0 4px 16px rgba(0,0,0,0.1)',
      '--shadow-md': '0 4px 12px rgba(0,0,0,0.1)', // 补充原有变量，避免样式报错
    };
    Object.keys(styles).forEach(key => {
      document.documentElement.style.setProperty(key, styles[key]);
    });
  },
  mounted() {
    // 初始化轮播图（确保轮播正常，不影响标签）
    new Swiper('.hero-swiper', {
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      autoHeight: false, // 关闭自适应高度，避免轮播图高度变化导致标签错位
      height: 380 // 固定轮播图高度
    });
  }
}
</script>

<style scoped>
/* 通用样式 */
.text-center { text-align: center; }

/* 英雄区基础布局 */
.hero {
  background-color: var(--bg-base);
  padding: var(--spacing-xl) 0;
}
.hero__wrap {
  display: grid;
  grid-template-columns: 55% 45%;
  gap: var(--spacing-xl);
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}
.hero__content {
  padding-right: var(--spacing-lg);
}
.hero-title {
  font-size: 38px;
  color: var(--primary-blue);
  margin: 0 0 var(--spacing-lg) 0;
  line-height: 1.3;
}
.hero-desc {
  font-size: 16px;
  color: var(--text-main);
  line-height: 1.6;
  margin: 0 0 var(--spacing-xl) 0;
  max-width: 500px;
  opacity: 0.85;
}

/* 按钮样式 */
.btn {
  display: inline-block;
  padding: 12px 24px;
  border-radius: var(--radius-md);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  border: none;
  outline: none;
}
.btn-primary {
  background-color: var(--primary-blue);
  color: var(--text-white);
  margin-right: var(--spacing-md);
}
.btn-primary:hover {
  background-color: #233d80;
  box-shadow: var(--shadow-sm);
}
.btn-outline {
  background-color: transparent;
  color: var(--primary-blue);
  border: 1px solid var(--primary-blue);
}
.btn-outline:hover {
  background-color: var(--light-blue);
  box-shadow: var(--shadow-sm);
}

/* 轮播图核心修复：固定尺寸+精准定位容器 */
.hero__carousel-wrapper {
  width: 100%;
  position: relative; /* 确保标签相对于该容器定位，不溢出 */
}
.hero__carousel {
  width: 100%;
  height: 380px; /* 固定高度，避免轮播图高度变化 */
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-tech);
  background: linear-gradient(145deg, #f8faff, #ffffff);
  border: 1px solid rgba(45, 75, 153, 0.08);
  position: relative; /* 标签定位的父级 */
}
.hero-swiper {
  width: 100%;
  height: 100%;
}
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 固定图片尺寸，不拉伸 */
}

/* 修复后的标签样式：精准定位+规整布局 */
.carousel-tag {
  position: absolute;
  z-index: 99; /* 确保标签在轮播图最上层 */
  border-radius: var(--radius-xl);
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  box-sizing: border-box; /* 内边距不影响尺寸 */
}
/* 标签1：自动提报商品（左上）- 精准定位 */
.tag-1 {
  top: 20px;
  left: 20px;
  background: var(--text-white);
  color: var(--text-main);
  padding: 8px 14px;
  gap: 8px;
}
/* 标签2：2000+商品/10分钟（左中）- 重构布局 */
.tag-2 {
  top: 90px;
  left: 20px;
  background: var(--primary-purple);
  color: var(--text-white);
  padding: 10px 12px;
  flex-direction: column;
  gap: 2px;
  min-width: 80px;
  text-align: center;
}
.tag-2 .tag-num {
  font-size: 18px;
  line-height: 1;
  font-weight: 600;
}
.tag-2 .tag-sub {
  font-size: 12px;
  opacity: 0.9;
  line-height: 1;
}
/* 标签3：效率提升10倍（右下）- 精准定位 */
.tag-3 {
  bottom: 20px;
  right: 20px;
  background: var(--text-white);
  color: var(--text-main);
  padding: 8px 14px;
  gap: 8px;
}
/* 标签内小图标 */
.tag-icon {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-white);
  font-size: 10px;
  font-weight: bold;
  flex-shrink: 0; /* 图标不压缩 */
}
.green-icon { background: var(--success-green); }
.blue-icon { background: var(--primary-blue); }
.tag-text {
  font-size: 14px;
  line-height: 1;
}

/* 新增：核心服务样式（和核心优势风格完全统一） */
.core-service {
  padding: var(--spacing-xl) 0;
  background-color: var(--light-blue); /* 浅蓝背景区分板块，更醒目 */
  margin-bottom: var(--spacing-lg); /* 和核心优势保持间距 */
}
.core-service__title {
  font-size: 28px;
  color: var(--text-main);
  margin: 0 0 var(--spacing-xl) 0;
  font-weight: 600;
}
.core-service__list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}
.core-service__item {
  padding: var(--spacing-xl);
  background: var(--bg-base);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  text-align: center;
  transition: all 0.3s ease;
}
.core-service__item:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}
.core-service__icon {
  color: var(--primary-blue);
  font-size: 32px;
  margin-bottom: var(--spacing-md);
}
.core-service__item-title {
  font-size: 18px;
  color: var(--text-main);
  margin: 0 0 var(--spacing-sm) 0;
  font-weight: 600;
}
.core-service__item-desc {
  font-size: 14px;
  color: var(--text-main);
  line-height: 1.5;
  margin: 0;
  opacity: 0.8;
}

/* 核心优势 */
.advantage {
  padding: var(--spacing-xl) 0;
  background-color: var(--bg-base);
}
.advantage__title {
  font-size: 28px;
  color: var(--text-main);
  margin: 0 0 var(--spacing-xl) 0;
  font-weight: 600;
}
.advantage__list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}
.advantage__item {
  padding: var(--spacing-xl);
  background: var(--bg-base);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  text-align: center;
  transition: all 0.3s ease;
}
.advantage__item:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
}
.advantage__icon {
  color: var(--primary-blue);
  font-size: 32px;
  margin-bottom: var(--spacing-md);
}
.advantage__item-title {
  font-size: 18px;
  color: var(--text-main);
  margin: 0 0 var(--spacing-sm) 0;
  font-weight: 600;
}
.advantage__item-desc {
  font-size: 14px;
  color: var(--text-main);
  line-height: 1.5;
  margin: 0;
  opacity: 0.8;
}

/* 用户好评 */
.testimonial {
  background: var(--bg-base);
  padding: var(--spacing-xl) 0;
}
.testimonial-title {
  font-size: 28px;
  color: var(--text-main);
  margin: 0 0 var(--spacing-sm) 0;
}
.blue-text {
  color: var(--primary-blue);
}
.testimonial-desc {
  max-width: 700px;
  margin: 0 auto var(--spacing-xl) auto;
  color: var(--text-main);
  font-size: 14px;
  opacity: 0.8;
  padding: 0 var(--spacing-md);
}
.testimonial__list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: var(--spacing-lg);
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}
.testimonial__card {
  background: var(--bg-base);
  padding: var(--spacing-lg);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  position: relative;
}
.testimonial__badge {
  position: absolute;
  top: -12px;
  left: var(--spacing-lg);
  width: 24px;
  height: 24px;
  background: var(--primary-blue);
  border-radius: 50%;
  color: var(--text-white);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.testimonial__stars {
  color: #FFC107;
  font-size: 16px;
  margin-bottom: var(--spacing-md);
}
.testimonial__content {
  line-height: 1.6;
  color: var(--text-main);
  font-size: 14px;
  margin-bottom: var(--spacing-md);
  opacity: 0.9;
}
.testimonial__achievement {
  background: var(--light-blue);
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  color: var(--text-main);
  font-size: 14px;
  margin-bottom: var(--spacing-lg);
}
.testimonial__user {
  display: flex;
  align-items: center;
  gap: 12px;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.user-name {
  font-weight: 600;
  color: var(--text-main);
  font-size: 14px;
}
.user-tag {
  font-size: 12px;
  color: var(--primary-blue);
}

/* 服务简介 */
.service-intro {
  background: var(--light-blue);
  padding: var(--spacing-xl) 0;
  margin-top: var(--spacing-xl);
}
.service-intro__content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}
.service-intro__title {
  font-size: 24px;
  color: var(--text-main);
  margin: 0 0 var(--spacing-md) 0;
  font-weight: 600;
}
.service-intro__desc {
  color: var(--text-main);
  line-height: 1.6;
  margin: 0 0 var(--spacing-lg) 0;
  font-size: 14px;
  opacity: 0.85;
}

/* 响应式适配：标签位置自适应 */
@media (max-width: 992px) {
  .hero__wrap {
    grid-template-columns: 1fr !important;
  }
  .hero__content {
    padding-right: 0;
    text-align: center;
  }
  .hero-desc {
    max-width: 100%;
    margin: 0 auto var(--spacing-lg) auto;
  }
  .hero__btns {
    justify-content: center;
    display: flex;
  }
  .hero__carousel {
    height: 300px;
    margin-top: var(--spacing-lg);
  }
  .hero-swiper {
    height: 100%;
  }
  .hero-title {
    font-size: 32px;
  }
  /* 移动端标签位置调整 */
  .tag-1 { top: 15px; left: 15px; padding: 6px 10px; }
  .tag-2 { top: 70px; left: 15px; padding: 8px 10px; }
  .tag-2 .tag-num { font-size: 16px; }
  .tag-3 { bottom: 15px; right: 15px; padding: 6px 10px; }
  .tag-text { font-size: 12px; }

  /* 核心服务移动端适配 */
  .core-service__item {
    padding: var(--spacing-lg);
  }
}

@media (max-width: 768px) {
  .testimonial__list {
    grid-template-columns: 1fr !important;
  }
  .testimonial-title {
    font-size: 24px;
  }
  .hero__carousel {
    height: 250px;
  }

  /* 核心服务/优势标题移动端适配 */
  .core-service__title, .advantage__title {
    font-size: 24px;
  }
}
</style>